import * as v from "valibot";

export const registerFreeLiveEventRpcContract = {
  name: "register-free-live-event",
  paramsSchema: v.object({
    eventId: v.string(),
  }),
  resultSchema: v.object({
    registered: v.boolean(),
  }),
};

export type RegisterFreeLiveEventParams = v.InferInput<typeof registerFreeLiveEventRpcContract.paramsSchema>;
export type RegisterFreeLiveEventResult = v.InferOutput<typeof registerFreeLiveEventRpcContract.resultSchema>;
